import React, { useState } from "react";
import {
    Button,
    Container,
    Form,
    Spinner,
    Image,
} from "react-bootstrap";
import LoginModal from "../LoginModal";
import { isValidEmail } from "../../util/validity-helpers";
import { useHistory } from "react-router-dom";
import { TertiaryButton } from "../TriyoButton";
import { TriyoForm } from "../TriyoForm";
import UsingComputer from "../../assets/Illustrations/UsingComputer-228px.svg";

import "./ForgotPassword.scss";
import { getResetLink } from "../../services/api/auth";
import { errorNotification } from "../../redux/notifications";
import { useDispatch } from "react-redux";

const ForgotPassword = () => {

    const history = useHistory();
    const dispatch = useDispatch();

    const [emailSent, setEmailSent] = useState(false);
    const [validated, setValidated] = useState(false);
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const onEmailChange = (e) => {
        setEmail(e.target.value);
    }

    const onSubmit = async () => {
        setLoading(true);
        setValidated(true);
        const validity = isValidEmail(email);
        if (!validity) {
            setLoading(false);
            return;
        }
        try {
            const result = await getResetLink(email);
            if (result.status === 200) {
                setEmailSent(true);
            }
            else {
                throw new Error("Password reset Request didn't work!");
            }
        } catch {
            dispatch(errorNotification({
                header: "Password reset failure",
                message: "There was an error, please try again later."
            }));
        }
        setLoading(false);
    }

    const backToLogin = () => {
        history.push("./login");
    }

    return (
        <LoginModal>
            {!emailSent ?
                <Container className="forget-password-form">
                    <h2>Having trouble logging in?</h2>
                    <h3>Enter your email address and we’ll send you instructions on regaining access to your TRIYO account.</h3>
                    <TriyoForm>
                        <Form noValidate validated={validated} autoComplete="off">
                            <Form.Group>
                                <Form.Label>Email address</Form.Label>
                                <Form.Control
                                    className="email-input input"
                                    type="text"
                                    value={email}
                                    onChange={onEmailChange}
                                    required
                                    isInvalid={validated && !isValidEmail(email)}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Email address is required
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Button className="next-button" onClick={onSubmit} disabled={loading}>
                                {loading && <Spinner className="nextButtonSpinner" as="span" animation="border" size="sm" role="status" />}
                                Continue
                            </Button>
                            <TertiaryButton text="Back to Login" onClick={backToLogin} disabled={loading} />
                        </Form>
                    </TriyoForm>
                </Container>
                :
                <Container className="forget-password-form">
                    <Image className="using-computer" src={UsingComputer} />
                    <h3 className="email-sent">
                        A password reset link has been sent to <b>{email || "undefined"}.</b> If your email address is associated with an account on TRIYO, you will receive an email with steps to regain access.
                    </h3>
                    <Button className="next-button" onClick={backToLogin} disabled={loading}>
                        Back to Login
                    </Button>
                </Container>
            }
        </LoginModal>
    );
}

export default ForgotPassword;